import(/* webpackMode: "eager", webpackExports: ["Beacon"] */ "/app/apps/search-ui/src/app/beacon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DatadogInit"] */ "/app/apps/search-ui/src/components/datadog/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ClientSideAuthChecker"] */ "/app/apps/search-ui/src/components/shared/auth-checker/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/search-ui/src/components/shared/error-boundary.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/search-ui/src/lib/context/auth.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/search-ui/src/lib/context/loading.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/search-ui/src/lib/context/theme.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/search-ui/src/styles/_animations.scss");
;
import(/* webpackMode: "eager" */ "/app/apps/search-ui/src/styles/_react-resizable.scss");
;
import(/* webpackMode: "eager", webpackExports: ["TRPCReactProvider"] */ "/app/apps/search-ui/src/trpc/react.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/@fortawesome+fontawesome-svg-core@6.7.2/node_modules/@fortawesome/fontawesome-svg-core/styles.css");
;
import(/* webpackMode: "eager" */ "/app/apps/search-ui/src/styles/_carousel.scss");
;
import(/* webpackMode: "eager" */ "/app/apps/search-ui/src/styles/global.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.3.3_@babel+core@7.28.0_@opentelemetry+api@1.9.0_babel-plugin-react-compiler@19._d46e1133b4c9988ff2383370a926a759/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\",\"variable\":\"--inter-font\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.3.3_@babel+core@7.28.0_@opentelemetry+api@1.9.0_babel-plugin-react-compiler@19._d46e1133b4c9988ff2383370a926a759/node_modules/next/font/local/target.css?{\"path\":\"src/app/font.ts\",\"import\":\"\",\"arguments\":[{\"src\":\"./TwemojiCountryFlags.woff2\",\"variable\":\"--twemoji-font\"}],\"variableName\":\"twemojiFont\"}");
;
import(/* webpackMode: "eager", webpackExports: ["NuqsAdapter"] */ "/app/node_modules/.pnpm/nuqs@2.4.3_next@15.4.5_@opentelemetry+api@1.9.0_react-dom@19.1.1_react@19.1.1__react@19.1.1_sass@1.89.2__react@19.1.1/node_modules/nuqs/dist/adapters/next/app.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/react-hot-toast@2.5.2_react-dom@19.1.1_react@19.1.1__react@19.1.1/node_modules/react-hot-toast/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/react-tooltip@5.29.1_react-dom@19.1.1_react@19.1.1__react@19.1.1/node_modules/react-tooltip/dist/react-tooltip.min.css");
;
import(/* webpackMode: "eager", webpackExports: ["WatchlistProvider"] */ "/app/packages/ui/src/components/add-to-watchlist/watchlist-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UpdateReminderModal"] */ "/app/packages/ui/src/components/update-reminder-modal/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/src/styles/theme/shared.scss");
